export default "__VITE_ASSET__DKr4vVHC__"